/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isArray } from 'lodash';
import { useComponent } from '../../../Pages/UserSetting/UsersLibrary/UserRights';
import { RightsAccess } from '../../helper';
import MenuItem from '../MenuItem';
import {
  BillOfMaterialsIcon,
  CareUserInstructionsIcon,
  CostingsIcon,
  CustomModulesIcon,
  DAMIcon,
  DesignDetailsIcon,
  DPPLibraryIcon,
  MeasurementsIcon,
  ProductIdentifierIcon,
  PurchaseOrdersIcon,
  SamplesIcon,
  TestingIcon,
} from '../../../bombiix-icon';

function DevorderUrl(props) {
  const { CheckModulePermission } = useComponent();
  const reducer = useSelector((reducerstate) => reducerstate);
  // eslint-disable-next-line sonarjs/no-duplicate-string

  const {
    BOMConfigDetails: { trafficLights },
    Users: { logInRights, moduleAccess },
    UserDetails: { isSupplierLoggedIn, isCompanyAdminLoggedIn },
    Measuremets: { customModuleMenu, customModuleLoaderState, dppModuleMenu },
  } = reducer;
  const { isMobileMenu } = props;
  const DesignAccesss = CheckModulePermission(logInRights, 'products', 'design', isCompanyAdminLoggedIn);
  const MeasurementAccess = CheckModulePermission(logInRights, 'products', 'measurement', isCompanyAdminLoggedIn);
  const BomAccess = CheckModulePermission(logInRights, 'products', 'bom', isCompanyAdminLoggedIn);
  const TestingAccess = CheckModulePermission(logInRights, 'products', 'testing', isCompanyAdminLoggedIn);
  const CareAccess = CheckModulePermission(logInRights, 'products', 'care', isCompanyAdminLoggedIn);
  const SampleAccess = CheckModulePermission(logInRights, 'products', 'samples', isCompanyAdminLoggedIn);
  const customModuleAccess = CheckModulePermission(logInRights, 'products', 'customModule', isCompanyAdminLoggedIn);
  const ProductCostingAccess = CheckModulePermission(logInRights, 'products', 'costing', isCompanyAdminLoggedIn);
  const PurchaseOrderAccess = CheckModulePermission(logInRights, 'products', 'purchaseOrder', isCompanyAdminLoggedIn);
  const DAMAccesss = CheckModulePermission(logInRights, 'products', 'DAM', isCompanyAdminLoggedIn);
  const ProductIdentifierAccess = CheckModulePermission(logInRights, 'products', 'productIdentifier', isCompanyAdminLoggedIn);

  const { dppAccess } = moduleAccess;
  const ids = useLocation();
  const { productCostingRight, purchaseOrderRight, customModuleRight, DAMRight, DPPRight, TestingRight } = RightsAccess();
  const devOrderId = ids.pathname.match(/\/development-order\/([0-9a-f]{24})/i)?.[1];

  const history = useHistory();
  const pathName = history.location.pathname;

  const trafficLightClassNames = (property) => {
    return trafficLights && property ? `colored-cls ${property}` : 'colored-cls';
  };
  const trafficLightCustomModuleClassNames = (libId) => {
    const colour = trafficLights?.additionalInformation?.filter((item) => item?.customLibId === libId && item !== null).map((item) => item.color);

    return `colored-cls ${isArray(colour) ? colour[0] : ''}`;
  };

  return (
    !customModuleLoaderState && (
      <ul>
        {moduleAccess?.productsAccess && ProductIdentifierAccess && (
          <MenuItem
            activeClassList={['/product-identifier']}
            pathName={pathName}
            linkTo={`/development-order/${devOrderId}/product-identifier`}
            IconComponent={ProductIdentifierIcon}
            titleKey="DEVORDER_URL.PRODUCT_IDENTIFIER"
            isMobileMenu={isMobileMenu}
          />
        )}
        {DesignAccesss && (
          <MenuItem
            activeClassList={['/design-details']}
            pathName={pathName}
            linkTo={`/development-order/${devOrderId}/design-details/list`}
            IconComponent={DesignDetailsIcon}
            titleKey="DEVORDER_URL.DESIGN_DETAILS"
            trafficLightStyle={trafficLightClassNames(trafficLights?.design)}
            isMobileMenu={isMobileMenu}
          />
        )}
        {BomAccess && (
          <MenuItem
            activeClassList={['/bom', '/bom-type']}
            pathName={pathName}
            linkTo={`/development-order/${devOrderId}/bom`}
            IconComponent={BillOfMaterialsIcon}
            titleKey="DEVORDER_URL.BOM"
            trafficLightStyle={trafficLightClassNames(trafficLights?.bom)}
            isMobileMenu={isMobileMenu}
          />
        )}

        {MeasurementAccess && (
          <MenuItem
            activeClassList={['/measurement']}
            pathName={pathName}
            linkTo={`/development-order/${devOrderId}/measurement`}
            IconComponent={MeasurementsIcon}
            titleKey="DEVORDER_URL.SPECIFICATIONS"
            trafficLightStyle={trafficLightClassNames(trafficLights?.measurement)}
            isMobileMenu={isMobileMenu}
          />
        )}
        {TestingAccess && TestingRight && (
          <MenuItem
            activeClassList={['/testing', 'testing-group']}
            pathName={pathName}
            linkTo={`/development-order/${devOrderId}/testing/testing-requirements`}
            IconComponent={TestingIcon}
            titleKey="DEVORDER_URL.TESTING"
            trafficLightStyle={trafficLightClassNames(trafficLights?.testing)}
            isMobileMenu={isMobileMenu}
          />
        )}

        {CareAccess && (
          <MenuItem
            activeClassList={['care-user-instruction']}
            pathName={pathName}
            linkTo={`/development-order/${devOrderId}/care-user-instruction`}
            IconComponent={CareUserInstructionsIcon}
            titleKey="DEVORDER_URL.CARE_USER_INSTRUCTIONS"
            trafficLightStyle={trafficLightClassNames(trafficLights?.care)}
            isMobileMenu={isMobileMenu}
          />
        )}
        {SampleAccess && (
          <MenuItem
            activeClassList={['sample']}
            pathName={pathName}
            linkTo={`/development-order/${devOrderId}/samples`}
            IconComponent={SamplesIcon}
            titleKey="DEVORDER_URL.SAMPLES"
            trafficLightStyle={trafficLightClassNames(trafficLights?.samples)}
            isMobileMenu={isMobileMenu}
          />
        )}

        {customModuleRight &&
          customModuleAccess &&
          customModuleMenu?.length > 0 &&
          customModuleMenu?.map((ele) => {
            return (
              <MenuItem
                key={ele}
                activeClassList={['/custom-module/']}
                activeId={ele?._id}
                pathName={pathName}
                linkTo={`/development-order/${devOrderId}/custom-module/${ele?._id}`}
                IconComponent={CustomModulesIcon}
                titleKey={ele.moduleName}
                trafficLightStyle={trafficLightCustomModuleClassNames(ele?._id)}
                isMobileMenu={isMobileMenu}
              />
            );
          })}
        {dppAccess &&
          DPPRight &&
          moduleAccess?.productsAccess &&
          dppModuleMenu?.length > 0 &&
          dppModuleMenu?.map((ele) => {
            return (
              <MenuItem
                key={ele}
                activeClassList={['dpp-module']}
                activeId={ele?._id}
                pathName={pathName}
                linkTo={`/development-order/${devOrderId}/dpp-module/${ele?._id}`}
                IconComponent={DPPLibraryIcon}
                titleKey={ele.dppName}
                trafficLightStyle={trafficLightCustomModuleClassNames(ele?._id)}
                isMobileMenu={isMobileMenu}
              />
            );
          })}

        {ProductCostingAccess && productCostingRight && (
          <MenuItem
            activeClassList={['product-costing']}
            pathName={pathName}
            linkTo={`/development-order/${devOrderId}/product-costing`}
            IconComponent={CostingsIcon}
            titleKey="DEVORDER_URL.PRODUCT_COSTING"
            trafficLightStyle={trafficLightClassNames(trafficLights?.costing)}
            isMobileMenu={isMobileMenu}
          />
        )}
        {PurchaseOrderAccess && purchaseOrderRight && (
          <MenuItem
            activeClassList={['product-purchase-order']}
            pathName={pathName}
            linkTo={`/development-order/${devOrderId}/product-purchase-order`}
            IconComponent={PurchaseOrdersIcon}
            titleKey="DEVORDER_URL.PURCHASE_ORDERS"
            trafficLightStyle={trafficLightClassNames(trafficLights?.po)}
            isMobileMenu={isMobileMenu}
          />
        )}
        {DAMAccesss && DAMRight && !isSupplierLoggedIn && (
          <MenuItem
            activeClassList={['digital-assets-management']}
            pathName={pathName}
            linkTo={`/development-order/${devOrderId}/digital-assets-management`}
            IconComponent={DAMIcon}
            titleKey="DEVORDER_URL.DAM"
            isMobileMenu={isMobileMenu}
          />
        )}
      </ul>
    )
  );
}

export default DevorderUrl;
